export enum DateType {
  CHECK_IN = 'CHECK_IN',
  CHECK_OUT = 'CHECK_OUT',
}

export const PDP_CHECKIN_QUERY_PARAM = 'chkin';
export const PDP_CHECKOUT_QUERY_PARAM = 'chkout';
